import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  /**
   * Holds the shared reference of the subject.
   */
  private subject = new Subject<any>();

  public constructor() {
  }
  public send(msg: string): void {
    this.subject.next({ text: msg });
  }

  clearMessages() {
    this.subject.next('');
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}